import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// 支持语言包
import zh from "./locales/zh.json";
import en from "./locales/en.json";
import ar from "./locales/ar.json";

const getBrowserLang = () => {
  const lang = navigator.language || "en";
//   console.log("浏览器语言:", lang);
  return lang.toLowerCase();
};

i18n
    .use(LanguageDetector) // 自动检测浏览器语言
    .use(initReactI18next)
    .init({
        lng: 'zh' , //getBrowserLang()
        resources: {
            zh: { translation: zh },
            en: { translation: en },
            ar: { translation: ar },
        },
        fallbackLng: "zh",
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;
